import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function WhoIsItFor() {
  const isFor = ["Padres con hijos de 2 a 12 años que se sienten derrotados por los 'picky eaters'.", 'Madres que trabajan y necesitan soluciones nutricionales de 15 minutos o menos.', 'Familias que ven cómo sus hijos se enferman cada vez que empieza el ciclo escolar.', 'Padres conscientes que saben que el marketing del súper les está mintiendo.'];
  const isNotFor = ["Personas que buscan pociones mágicas o gomitas de vitaminas para 'arreglarlo' todo.", 'Padres que no están dispuestos a cambiar lo que ponen en el carrito del supermercado.', 'Fanáticos de las dietas extremas que quieren quitarle el placer de comer a sus hijos.'];
  return <section className="py-14 bg-cream" data-id="element-206">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-207">
        <FadeIn data-id="element-208">
          <div className="max-w-3xl mx-auto mb-12" data-id="element-209">
            <img src="https://cdn.magicpatterns.com/uploads/sd4ffjVnnQnpeuWs51zy9c/ChatGPT_Image_Mar_31,_2026,_12_00_24_AM.png" alt="Familia feliz cenando junta con comida saludable" className="w-full h-64 md:h-80 object-cover rounded-3xl shadow-lg" data-id="element-210" />
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-211">
          {/* Para quién ES */}
          <FadeIn direction="right" data-id="element-212">
            <div className="bg-white rounded-3xl p-8 md:p-10 shadow-sm border-t-4 border-leaf h-full" data-id="element-213">
              <h3 className="text-2xl font-bold text-ink mb-8 flex items-center" data-id="element-214">
                Este manual{' '}
                <span className="text-leaf ml-2" data-id="element-215">ES para ti si...</span>
              </h3>
              <ul className="space-y-6" data-id="element-216">
                {isFor.map((text, i) => <li key={i} className="flex items-start" data-id="element-217">
                    <CheckCircle2Icon className="w-6 h-6 text-leaf mr-4 flex-shrink-0 mt-0.5" data-id="element-218" />
                    <span className="text-ink/80 leading-relaxed" data-id="element-219">{text}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Para quién NO ES */}
          <FadeIn direction="left" delay={0.2} data-id="element-220">
            <div className="bg-white/50 rounded-3xl p-8 md:p-10 border border-ink/5 h-full" data-id="element-221">
              <h3 className="text-2xl font-bold text-ink/60 mb-8 flex items-center" data-id="element-222">
                Este manual{' '}
                <span className="text-red-500/80 ml-2" data-id="element-223">
                  NO es para ti si...
                </span>
              </h3>
              <ul className="space-y-6" data-id="element-224">
                {isNotFor.map((text, i) => <li key={i} className="flex items-start opacity-70" data-id="element-225">
                    <XCircleIcon className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-226" />
                    <span className="text-ink/80 leading-relaxed" data-id="element-227">{text}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}